import { defineNuxtPlugin } from '#app'
import VueScrollTo from 'vue-scrollto'

export default defineNuxtPlugin({
  name: 'scrollTo',
  setup(nuxtApp) {
    nuxtApp.vueApp.directive('scroll-to', VueScrollTo)
    return {
      provide: {
        scrollTo: VueScrollTo.scrollTo,
      },
    }
  },
})
